import { Component } from '@angular/core';

import {AlertController, App, NavController} from 'ionic-angular';
import { ModalController, ViewController, ToastController } from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import {UiData} from "../../../providers/ui-data";
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import {DocumentSelectForm} from "../../utils/document-select/document-select";
import { DocumentViewer } from '../../utils/document-viewer/document-viewer';
import {HomePage} from "../../home/home";

@Component({
    selector: 'page-salaries',
    templateUrl: 'salaries.html'
})
export class SalariesPage {
    formationsRef: any;
    experiencesRef: any;
    certificatesRef: any;
    languagesRef: any;
    formations: Observable<any[]>;
    experiences: Observable<any[]>;
    certificates: Observable<any[]>;
    languages: Observable<any[]>;
    salaries: any;
    video_documents: any;


    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public afDatabase: AngularFireDatabase,
        private formBuilder: FormBuilder,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,
        public app: App
    ) {
        //userData.setToken('nova2');
    }
    back(event)
    {

        try{
            this.app.getRootNav().setRoot(HomePage);
            this.app.getRootNav().popToRoot();
        }catch(e){}
    }
    ngAfterViewInit() {

        var that = this;
        this.userData.load().subscribe(data => {
            that.loadSalaries()
        });

    }
    loadSalaries()
    {
        var that = this;
        that.salaries = this.userData.get('documentsPaySheets');
        if(!that.salaries)that.salaries=[];

    }
    download(object)
    {
        window.open(object.download, '_system');
    }

    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
    toastCancel(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/account/salaries/salaries.ts